import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _bookingPolicyViolations = {
    earliestBookingDate: 'google.protobuf.Timestamp',
};
var _getAvailabilityTimeSlotRequest = {};
var _getAvailabilityTimeSlotResponse = { timeSlot: '_timeSlot' };
var _getEventTimeSlotRequest = {};
var _getEventTimeSlotResponse = { timeSlot: '_timeSlot' };
var _getMultiServiceAvailabilityTimeSlotRequest = {};
var _getMultiServiceAvailabilityTimeSlotResponse = { timeSlot: '_timeSlot' };
var _listAvailabilityTimeSlotsRequest = {
    bookingPolicyViolations: '_bookingPolicyViolations',
};
var _listAvailabilityTimeSlotsResponse = { timeSlots: '_timeSlot' };
var _listEventTimeSlotsRequest = {};
var _listEventTimeSlotsResponse = { timeSlots: '_timeSlot' };
var _listMultiServiceAvailabilityTimeSlotsRequest = {
    bookingPolicyViolations: '_bookingPolicyViolations',
};
var _listMultiServiceAvailabilityTimeSlotsResponse = {
    timeSlots: '_timeSlot',
};
var _timeSlot = { bookingPolicyViolations: '_bookingPolicyViolations' };
function resolveComWixpressBookingsAvailabilityV2EventTimeSlotsUrl(opts) {
    var domainToMappings = {
        'www.wixapis.com': [
            {
                srcPath: '/_api/service-availability/v2/time-slots',
                destPath: '/v2/time-slots',
            },
            {
                srcPath: '/_api/service-availability/v2/multi-service-time-slots',
                destPath: '/v2/multi-service-time-slots',
            },
            {
                srcPath: '/service-availability/v2/time-slots',
                destPath: '/v2/time-slots',
            },
            {
                srcPath: '/service-availability/v2/multi-service-time-slots',
                destPath: '/v2/multi-service-time-slots',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/service-availability/v2/time-slots',
                destPath: '/v2/time-slots',
            },
            {
                srcPath: '/_api/service-availability/v2/multi-service-time-slots',
                destPath: '/v2/multi-service-time-slots',
            },
            {
                srcPath: '/service-availability/v2/time-slots',
                destPath: '/v2/time-slots',
            },
            {
                srcPath: '/service-availability/v2/multi-service-time-slots',
                destPath: '/v2/multi-service-time-slots',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/service-availability/v2/time-slots',
                destPath: '/v2/time-slots',
            },
            {
                srcPath: '/_api/service-availability/v2/multi-service-time-slots',
                destPath: '/v2/multi-service-time-slots',
            },
            {
                srcPath: '/service-availability/v2/multi-service-time-slots',
                destPath: '/v2/multi-service-time-slots',
            },
            {
                srcPath: '/service-availability/v2/time-slots',
                destPath: '/v2/time-slots',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/service-availability/v2/time-slots',
                destPath: '/v2/time-slots',
            },
            {
                srcPath: '/_api/service-availability/v2/multi-service-time-slots',
                destPath: '/v2/multi-service-time-slots',
            },
        ],
        _: [
            {
                srcPath: '/_api/service-availability/v2/time-slots',
                destPath: '/v2/time-slots',
            },
            {
                srcPath: '/_api/service-availability/v2/multi-service-time-slots',
                destPath: '/v2/multi-service-time-slots',
            },
            {
                srcPath: '/_api/service-availability/v2/time-slots/event',
                destPath: '/v2/time-slots/event',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/service-availability/v2/multi-service-time-slots',
                destPath: '/v2/multi-service-time-slots',
            },
            {
                srcPath: '/_api/service-availability/v2/time-slots',
                destPath: '/v2/time-slots',
            },
            {
                srcPath: '/_api/service-availability/v2/time-slots/event',
                destPath: '/v2/time-slots/event',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/service-availability/v2/multi-service-time-slots',
                destPath: '/v2/multi-service-time-slots',
            },
            {
                srcPath: '/_api/service-availability/v2/time-slots',
                destPath: '/v2/time-slots',
            },
            {
                srcPath: '/_api/service-availability/v2/time-slots/event',
                destPath: '/v2/time-slots/event',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/service-availability/v2/multi-service-time-slots',
                destPath: '/v2/multi-service-time-slots',
            },
            {
                srcPath: '/_api/service-availability/v2/time-slots',
                destPath: '/v2/time-slots',
            },
            {
                srcPath: '/_api/service-availability/v2/time-slots/event',
                destPath: '/v2/time-slots/event',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/service-availability/v2/time-slots/event',
                destPath: '/v2/time-slots/event',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressBookingsAvailabilityV2AvailabilityTimeSlotsUrl(opts) {
    var domainToMappings = {
        'www.wixapis.com': [
            {
                srcPath: '/_api/service-availability/v2/time-slots',
                destPath: '/v2/time-slots',
            },
            {
                srcPath: '/_api/service-availability/v2/multi-service-time-slots',
                destPath: '/v2/multi-service-time-slots',
            },
            {
                srcPath: '/service-availability/v2/time-slots',
                destPath: '/v2/time-slots',
            },
            {
                srcPath: '/service-availability/v2/multi-service-time-slots',
                destPath: '/v2/multi-service-time-slots',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/service-availability/v2/time-slots',
                destPath: '/v2/time-slots',
            },
            {
                srcPath: '/_api/service-availability/v2/multi-service-time-slots',
                destPath: '/v2/multi-service-time-slots',
            },
            {
                srcPath: '/service-availability/v2/time-slots',
                destPath: '/v2/time-slots',
            },
            {
                srcPath: '/service-availability/v2/multi-service-time-slots',
                destPath: '/v2/multi-service-time-slots',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/service-availability/v2/time-slots',
                destPath: '/v2/time-slots',
            },
            {
                srcPath: '/_api/service-availability/v2/multi-service-time-slots',
                destPath: '/v2/multi-service-time-slots',
            },
            {
                srcPath: '/service-availability/v2/multi-service-time-slots',
                destPath: '/v2/multi-service-time-slots',
            },
            {
                srcPath: '/service-availability/v2/time-slots',
                destPath: '/v2/time-slots',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/service-availability/v2/time-slots',
                destPath: '/v2/time-slots',
            },
            {
                srcPath: '/_api/service-availability/v2/multi-service-time-slots',
                destPath: '/v2/multi-service-time-slots',
            },
        ],
        _: [
            {
                srcPath: '/_api/service-availability/v2/time-slots',
                destPath: '/v2/time-slots',
            },
            {
                srcPath: '/_api/service-availability/v2/multi-service-time-slots',
                destPath: '/v2/multi-service-time-slots',
            },
            {
                srcPath: '/_api/service-availability/v2/time-slots/event',
                destPath: '/v2/time-slots/event',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/service-availability/v2/multi-service-time-slots',
                destPath: '/v2/multi-service-time-slots',
            },
            {
                srcPath: '/_api/service-availability/v2/time-slots',
                destPath: '/v2/time-slots',
            },
            {
                srcPath: '/_api/service-availability/v2/time-slots/event',
                destPath: '/v2/time-slots/event',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/service-availability/v2/multi-service-time-slots',
                destPath: '/v2/multi-service-time-slots',
            },
            {
                srcPath: '/_api/service-availability/v2/time-slots',
                destPath: '/v2/time-slots',
            },
            {
                srcPath: '/_api/service-availability/v2/time-slots/event',
                destPath: '/v2/time-slots/event',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/service-availability/v2/multi-service-time-slots',
                destPath: '/v2/multi-service-time-slots',
            },
            {
                srcPath: '/_api/service-availability/v2/time-slots',
                destPath: '/v2/time-slots',
            },
            {
                srcPath: '/_api/service-availability/v2/time-slots/event',
                destPath: '/v2/time-slots/event',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/service-availability/v2/time-slots/event',
                destPath: '/v2/time-slots/event',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressBookingsAvailabilityV2MultiServiceAvailabilityTimeSlotsUrl(opts) {
    var domainToMappings = {
        'www.wixapis.com': [
            {
                srcPath: '/_api/service-availability/v2/time-slots',
                destPath: '/v2/time-slots',
            },
            {
                srcPath: '/_api/service-availability/v2/multi-service-time-slots',
                destPath: '/v2/multi-service-time-slots',
            },
            {
                srcPath: '/service-availability/v2/time-slots',
                destPath: '/v2/time-slots',
            },
            {
                srcPath: '/service-availability/v2/multi-service-time-slots',
                destPath: '/v2/multi-service-time-slots',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/service-availability/v2/time-slots',
                destPath: '/v2/time-slots',
            },
            {
                srcPath: '/_api/service-availability/v2/multi-service-time-slots',
                destPath: '/v2/multi-service-time-slots',
            },
            {
                srcPath: '/service-availability/v2/time-slots',
                destPath: '/v2/time-slots',
            },
            {
                srcPath: '/service-availability/v2/multi-service-time-slots',
                destPath: '/v2/multi-service-time-slots',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/service-availability/v2/time-slots',
                destPath: '/v2/time-slots',
            },
            {
                srcPath: '/_api/service-availability/v2/multi-service-time-slots',
                destPath: '/v2/multi-service-time-slots',
            },
            {
                srcPath: '/service-availability/v2/multi-service-time-slots',
                destPath: '/v2/multi-service-time-slots',
            },
            {
                srcPath: '/service-availability/v2/time-slots',
                destPath: '/v2/time-slots',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/service-availability/v2/time-slots',
                destPath: '/v2/time-slots',
            },
            {
                srcPath: '/_api/service-availability/v2/multi-service-time-slots',
                destPath: '/v2/multi-service-time-slots',
            },
        ],
        _: [
            {
                srcPath: '/_api/service-availability/v2/time-slots',
                destPath: '/v2/time-slots',
            },
            {
                srcPath: '/_api/service-availability/v2/multi-service-time-slots',
                destPath: '/v2/multi-service-time-slots',
            },
            {
                srcPath: '/_api/service-availability/v2/time-slots/event',
                destPath: '/v2/time-slots/event',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/service-availability/v2/multi-service-time-slots',
                destPath: '/v2/multi-service-time-slots',
            },
            {
                srcPath: '/_api/service-availability/v2/time-slots',
                destPath: '/v2/time-slots',
            },
            {
                srcPath: '/_api/service-availability/v2/time-slots/event',
                destPath: '/v2/time-slots/event',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/service-availability/v2/multi-service-time-slots',
                destPath: '/v2/multi-service-time-slots',
            },
            {
                srcPath: '/_api/service-availability/v2/time-slots',
                destPath: '/v2/time-slots',
            },
            {
                srcPath: '/_api/service-availability/v2/time-slots/event',
                destPath: '/v2/time-slots/event',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/service-availability/v2/multi-service-time-slots',
                destPath: '/v2/multi-service-time-slots',
            },
            {
                srcPath: '/_api/service-availability/v2/time-slots',
                destPath: '/v2/time-slots',
            },
            {
                srcPath: '/_api/service-availability/v2/time-slots/event',
                destPath: '/v2/time-slots/event',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/service-availability/v2/time-slots/event',
                destPath: '/v2/time-slots/event',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Retrieves a list of multiService `TimeSlot`s that match the provided filters.
 *
 * <blockquote class="important">
 * <p><strong>Important:</strong><br/>
 * Currently supported only for services of type <code class="grey-background">APPOINTMENT</code>.</p>
 * </blockquote>
 *
 * The request body __must__ include either:
 * + All of the following filters:  `service`.`serviceId`, `fromLocalDate`, `toLocalDate`, `location`, and `timeZone`. You may add additional filters as you wish.
 * + A `cursorPaging` with a valid `cursor` from previous response.
 *
 *
 * Each [TimeSlot](https://bo.wix.com/wix-docs/rest/all-apis/wix-service-availability/availability-time-slots/time-slot-object) in response
 * represents the availability of the given sequence of services in a specific order, location, and within a given range of time.
 *
 * Each `TimeSlot`.`NestedTimeSlot` represents a single service from the given list. The order of the `NestedTimeSlots` is the same as the order
 * of the given services in request.
 * The first `NestedTimeSlot` has `localStartDate` within the given `fromLocalDate` and `toLocalDate` exclusive,
 * and each following `NestedTimeSlot` has a `localStartDate` that equals to the previous `NestedTimeSlot`'s `localEndDate`.
 *
 * By default,
 * the response contains at most 1000 results.
 * If there are more than 1000 results, we return a `cursorPagingMetadata` with
 * a cursor for the next page of results, regardless of whether a `cursorPaging`
 * was provided in request.
 *
 * > __Notes:__
 * >  + All nested time slots share the same location.
 * >  + You can pass up to 8 services in request.
 *
 * ### AvailableResources in response:
 * The `TimeSlot`.`NestedTimeSlot`'s `AvailableResources` contains information about the resources that are available to provide the service
 * within the `NestedTimeSlot` range of time. Each `AvailableResources` contains information about available resources of the same type.
 *
 * <blockquote class="important">
 * <p><strong>Important:</strong><br/>
 * By default,
 * if you don't specify <code class="grey-background">service</code>.<code class="grey-background">includeResourceTypeIds</code>
 * or  <code class="grey-background">service</code>.<code class="grey-background">resourceIds</code> filters in request,
 * we return TimeSlots with <code class="grey-background">NestedTimeSlot</code>s with an empty <code class="grey-background">AvailableResources</code>.
 * <br/><strong>Note:</strong><br/> Not specifying resources filters can be handy in case you want to avoid large response in flows that only
 * interested of whether the time slots are available. [Finding the next available slot within the next 3 months](https://bo.wix.com/wix-docs/rest/all-apis/service-availability/multi-service-availability-time-slots/sample-flows?localViewerId=inbari#all-apis_service-availability_multi-service-availability-time-slots_sample-flows_find-the-first-date-within-the-next-3-months-that-all-selected-services-are-available-for)
 * is an example for such flow.
 * </p>
 * </blockquote>
 *
 *
 * If you wish to get a list of available resources for a `TimeSlot`.`NestedTimeSlot` you should either:
 * + provide `service`.`resourceIds` in request.
 * + provide `service`.`includeResourceTypeIds` in request.
 *
 * __Notes:__
 * + In both cases the returned `TimeSlot`.`NestedTimeSlot` contains  __up__ to 10 `AvailableResources` that match the provided filters. Each `AvailableResources` contains __up__ to 10 available `resources` of the same type that match the provided filters.
 * + If an `AvailableResources` has more available resources which are not listed within it, we return `AvailableResources`.`hasMoreAvailableResources` as true.
 * + If you wish to get the full available resources list for all `NestedTimeSlot` of a specific `TimeSlot`, you should call [GetMultiServiceAvailabilityTimeSlot](https://bo.wix.com/wix-docs/rest/all-apis/wix-service-availability/multi-service-availability-time-slots/get-multi-service-availability-time-slot).
 *
 *
 * ### Availability VS Bookability
 * An `available` time slot is not necessarily `bookable`.
 * The `bookable` field of a `TimeSlot` indicates whether the customer can book all of the of the services within the given time slot,
 * at a specific period of time.
 * Read more about [Availability VS Bookability](https://bo.wix.com/wix-docs/rest/all-apis/wix-service-availability/multi-service-availability-time-slots/introduction#all-apis_wix-service-availability_multi-service-availability-time-slots_introduction_availability-vs-bookability).
 *
 * By default,
 * + The response does not contains `unavailable` TimeSlots.For example, if there are no available resources to provide one of the services from `2024-01-30T14:30:00` to `2024-01-30T15:30:00`, we don't return TimeSlots with `NestedTimeSlot`.`localStartDate` within this range for this service.
 * + The response contains both `bookable` and `un-bookable` TimeSlots.For example, if one of the services has a booking policy which enforces booking the service up to 10 minutes before the session starts, we return TimeSlots with the violating `NestedTimeSlot`.`localStartDate`, with `bookable` as `false`. If you want to list only __bookable__ TimeSlots you should pass `bookable` as `true`.
 * + If booking one of the `NestedTimeSlot`s violates one of the corresponding service's booking policies, the `TimeSlot` returns with `bookable` as false. There is no indication which service's policy was violated.
 *
 * <blockquote class="important">
 * <p><strong>Important:</strong>
 * Because of DST, there are edge cases where certain times either do not exist or exist twice for a local time zone.
 * Read more about <a href="https://bo.wix.com/wix-docs/rest/all-apis/wix-service-availability/multi-service-availability-time-slots/introduction#all-apis_wix-service-availability_multi-service-availability-time-slots_introduction_daylight-saving-time-dst-handling">DST Handling</a></p>
 * </blockquote>
 *
 * ### ListAvailabilityTimeSlots runs with the following defaults:
 * + `localStartDate` is sorted in `ASC` order.
 * + `cursorPaging`.`limit` is `1000`.
 */
export function listMultiServiceAvailabilityTimeSlots(payload) {
    var _a = serializer(_listMultiServiceAvailabilityTimeSlotsRequest, { _bookingPolicyViolations: _bookingPolicyViolations }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listMultiServiceAvailabilityTimeSlotsResponse, { _bookingPolicyViolations: _bookingPolicyViolations, _timeSlot: _timeSlot }).fromJSON;
    function __listMultiServiceAvailabilityTimeSlots(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.availability.v2.time_slot',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.availability.v2.MultiServiceAvailabilityTimeSlots.ListMultiServiceAvailabilityTimeSlots',
            url: resolveComWixpressBookingsAvailabilityV2MultiServiceAvailabilityTimeSlotsUrl({
                protoPath: '/v2/multi-service-time-slots',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listMultiServiceAvailabilityTimeSlots.fromReq = fromReq;
    __listMultiServiceAvailabilityTimeSlots.__isAmbassador = true;
    return __listMultiServiceAvailabilityTimeSlots;
}
/**
 * Retrieves an available multiService `TimeSlot` that match the provided filters.
 *
 * Throws `SlotNotFound` if there is no such available time slot.
 *
 * <blockquote class="important">
 * <p><strong>Important:</strong><br/>
 * Currently supported only for services of type <code class="grey-background">APPOINTMENT</code>.</p>
 * </blockquote>
 *
 * By default,
 * if you don't provide a `service`.`includeResourceTypeIds` or `service`.`resourceIds` in request,
 * we return for each `TimeSlot`.`NestedTimeSlot` all `AvailableResources` with all `AvailableResources`.`resources` which are available to provide
 * the corresponding service within the time slot.
 *
 * If you specify `service`.`includeResourceTypeIds` or `service`.`resourceIds` in request,
 * the returned `TimeSlot`.`NestedTimeSlot` for this service will contain only `AvailableResources` with at least one available resource
 * which match the given resources filters,
 * each contains all available resources out of those requested.
 *
 * + Notes:
 * + All nested time slots share the same location.
 * + You can pass up to 8 services.
 *
 * <blockquote class="tip">
 * <p><strong>Tip:</strong><br/>
 * Use this API in order to get the availability of a specific <code class="grey-background">TimeSlot</code> out of those returned from  <code class="grey-background">ListMultiServiceAvailabilityTimeSlots</code> API.</p>
 * </blockquote>
 */
export function getMultiServiceAvailabilityTimeSlot(payload) {
    var _a = serializer(_getMultiServiceAvailabilityTimeSlotRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getMultiServiceAvailabilityTimeSlotResponse, { _bookingPolicyViolations: _bookingPolicyViolations, _timeSlot: _timeSlot }).fromJSON;
    function __getMultiServiceAvailabilityTimeSlot(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.availability.v2.time_slot',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.availability.v2.MultiServiceAvailabilityTimeSlots.GetMultiServiceAvailabilityTimeSlot',
            url: resolveComWixpressBookingsAvailabilityV2MultiServiceAvailabilityTimeSlotsUrl({
                protoPath: '/v2/multi-service-time-slots/get',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getMultiServiceAvailabilityTimeSlot.fromReq = fromReq;
    __getMultiServiceAvailabilityTimeSlot.__isAmbassador = true;
    return __getMultiServiceAvailabilityTimeSlot;
}
/**
 * Retrieves a list of `TimeSlot`s that match the provided filters.
 *
 * <blockquote class="important">
 * <p><strong>Important:</strong>
 * Currently supported only for services of type <code class="grey-background">APPOINTMENT</code>.</p>
 * </blockquote>
 *
 * The request body __must__ include either:
 * + All of the following filters:  `serviceId`, `fromLocalDate`, `toLocalDate`, and `timeZone`.
 * You may add additional filters as you wish.
 * + A `cursorPaging` with a valid `cursor` from previous response.
 *
 *
 * Each [TimeSlot](https://bo.wix.com/wix-docs/rest/all-apis/wix-service-availability/availability-time-slots/time-slot-object) in response
 * represents the availability of the service in a specific location,
 * and has a `localStartDate` within the range of the provided `fromLocalDate` and `toLocalDate` exclusive.
 * The `localEndDate` of a `TimeSlot` is calculated as the sum of the `TimeSlot`'s `localStartDate` and the duration of the service.
 *
 * By default,
 * the response contains at most 1000 results.
 * If there are more than 1000 results, we return a `cursorPagingMetadata` with
 * a cursor for the next page of results, regardless of whether a `cursorPaging`
 * was provided in request.
 *
 * ### AvailableResources in response
 * The `TimeSlot`'s `AvailableResources` contains information about the resources that are available to provide the service
 * within the time slot. Each `AvailableResources` contains information about available resources of the same type.
 *
 * <blockquote class="important">
 * <p><strong>Important:</strong><br/>
 * By default,
 * if you don't specify <code class="grey-background">includeResourceTypeIds</code>
 * or <code class="grey-background">resourceIds</code> filters in request,
 * we return TimeSlots with an empty <code class="grey-background">AvailableResources</code>.
 * <br/><strong>Note:</strong><br/> Not specifying resources filters can be handy in case you want to avoid large response in flows that only
 * interested of whether the time slots are available. [Finding the next available slot within the next 3 months](https://bo.wix.com/wix-docs/rest/all-apis/service-availability/availability-time-slots/sample-flows?localViewerId=inbari#all-apis_service-availability_availability-time-slots_sample-flows_find-the-first-date-within-the-next-3-months-that-the-selected-service-is-available-for)
 * is an example for such flow.
 * </p>
 * </blockquote>
 *
 * If you wish to get a list of available resources for each `TimeSlot` you should either:
 * + provide `resourceIds` in request.
 * + provide `includeResourceTypeIds` in request.
 *
 * __Notes:__
 * + In both cases the returned TimeSlots contains  __up__ to 10 `AvailableResources` that match the provided filters.
 * Each `AvailableResources` contains __up__ to 10 available `resources` of the same type that match the provided filters.
 * + If an `AvailableResources` has more available resources which are not listed within it,
 * we return `AvailableResources`.`hasMoreAvailableResources` as true.
 * > __Note:__
 * > If you wish to get the full available resources list for a specific `TimeSlot`,
 * > you should call [GetAvailabilityTimeSlot](https://bo.wix.com/wix-docs/rest/all-apis/wix-service-availability/service-availability-time-slots/get-availability-time-slot).
 *
 *
 * ### Availability VS Bookability
 * An `available` time slot is not necessarily `bookable`.
 * The `bookable` field of a `TimeSlot` indicates whether a customer can book the service within the given time slot,
 * at a specific period of time.
 * Read more about [Availability VS Bookability](https://bo.wix.com/wix-docs/rest/all-apis/wix-service-availability/service-availability-time-slots/introduction#all-apis_wix-service-availability_service-availability-time-slots_introduction_availability-vs-bookability).
 *
 * By default,
 * + The response does not contains `unavailable` TimeSlots.
 * For example,
 * if there are no available resources to provide the service from `2024-01-30T14:30:00` to `2024-01-30T15:30:00`,
 * we don't return TimeSlots with `localStartDate` within this range.
 * + The response contains both `bookable` and `un-bookable` TimeSlots.
 * For example,
 * if the service has a booking policy which enforces booking the service up to 10 minutes before the session starts,
 * we return TimeSlots with the violating `localStartDate` with `bookable` as false.
 * If you wish to list only available __bookable__ TimeSlots you should pass `bookable` filter as true.
 *
 * <blockquote class="important">
 * <p><strong>Important:</strong>
 * Because of DST, there are edge cases where certain times either do not exist or exist twice for a local time zone.
 * Read more about <a href="https://bo.wix.com/wix-docs/rest/all-apis/service-availability/availability-time-slots/introduction?localViewerId=inbari#all-apis_service-availability_availability-time-slots_introduction_daylight-saving-time-dst-handling">DST Handling</a></p>
 * </blockquote>
 *
 *
 * ### ListAvailabilityTimeSlots runs with the following defaults
 * + `localStartDate` is sorted in `ASC` order
 * + `cursorPaging`.`limit` is `1000`
 */
export function listAvailabilityTimeSlots(payload) {
    var _a = serializer(_listAvailabilityTimeSlotsRequest, { _bookingPolicyViolations: _bookingPolicyViolations }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listAvailabilityTimeSlotsResponse, {
        _bookingPolicyViolations: _bookingPolicyViolations,
        _timeSlot: _timeSlot,
    }).fromJSON;
    function __listAvailabilityTimeSlots(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.availability.v2.time_slot',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.availability.v2.AvailabilityTimeSlots.ListAvailabilityTimeSlots',
            url: resolveComWixpressBookingsAvailabilityV2AvailabilityTimeSlotsUrl({
                protoPath: '/v2/time-slots',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listAvailabilityTimeSlots.fromReq = fromReq;
    __listAvailabilityTimeSlots.__isAmbassador = true;
    return __listAvailabilityTimeSlots;
}
/**
 * Retrieves an available `TimeSlot` that match the provided filters.
 *
 * Throws `SlotNotFound` if there is no such available time slot.
 *
 * <blockquote class="important">
 * <p><strong>Important:</strong><br/>
 * Currently supported only for services of type <code class="grey-background">APPOINTMENT</code>.</p>
 * </blockquote>
 *
 * By default,
 * if you don't provide `includeResourceTypeIds` or `resourceIds` in request,
 * we return all `AvailableResources` with all `AvailableResources`.`resources` which are available to provide
 * the service within the time slot.
 *
 * If you specify `includeResourceTypeIds` or `resourceIds` in request,
 * the returned `TimeSlot` will contain only `AvailableResources` with at least one available resource
 * which match the given resources filters,
 * each contains all available resources out of those requested.
 *
 *
 * <blockquote class="tip">
 * <p><strong>Tip:</strong><br/>
 * Use this API in order to get the availability of a specific <code class="grey-background">TimeSlot</code> out of those returned from  <code class="grey-background">ListAvailabilityTimeSlots</code> API.</p>
 * </blockquote>
 */
export function getAvailabilityTimeSlot(payload) {
    var _a = serializer(_getAvailabilityTimeSlotRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getAvailabilityTimeSlotResponse, {
        _bookingPolicyViolations: _bookingPolicyViolations,
        _timeSlot: _timeSlot,
    }).fromJSON;
    function __getAvailabilityTimeSlot(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.availability.v2.time_slot',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.availability.v2.AvailabilityTimeSlots.GetAvailabilityTimeSlot',
            url: resolveComWixpressBookingsAvailabilityV2AvailabilityTimeSlotsUrl({
                protoPath: '/v2/time-slots/get',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getAvailabilityTimeSlot.fromReq = fromReq;
    __getAvailabilityTimeSlot.__isAmbassador = true;
    return __getAvailabilityTimeSlot;
}
/**
 * Retrieves event time slots based on specified filters.
 *
 * Event time slots are predefined events that customers can book, subject to capacity and booking policies.
 * By default, the Bookings app provides the events (classes) and the bookings policy.
 *
 * `ListEventTimeSlots` runs with these defaults, which you can override:
 * - `providerId` is the Bookings app ID.
 * - `timeZone` is the business time zone.
 * - `cursorPaging.limit` is `50`.
 * - Both bookable and non-bookable time slots are returned.
 *
 * Time slots are always sorted by their start time in ascending order.
 */
export function listEventTimeSlots(payload) {
    var _a = serializer(_listEventTimeSlotsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listEventTimeSlotsResponse, {
        _bookingPolicyViolations: _bookingPolicyViolations,
        _timeSlot: _timeSlot,
    }).fromJSON;
    function __listEventTimeSlots(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.availability.v2.time_slot',
            method: 'POST',
            methodFqn: 'com.wixpress.bookings.availability.v2.EventTimeSlots.ListEventTimeSlots',
            url: resolveComWixpressBookingsAvailabilityV2EventTimeSlotsUrl({
                protoPath: '/v2/time-slots/event',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listEventTimeSlots.fromReq = fromReq;
    __listEventTimeSlots.__isAmbassador = true;
    return __listEventTimeSlots;
}
/** Retrieves the details of a specific event time slot based on the provided event ID. */
export function getEventTimeSlot(payload) {
    var _a = serializer(_getEventTimeSlotRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getEventTimeSlotResponse, {
        _bookingPolicyViolations: _bookingPolicyViolations,
        _timeSlot: _timeSlot,
    }).fromJSON;
    function __getEventTimeSlot(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.availability.v2.time_slot',
            method: 'GET',
            methodFqn: 'com.wixpress.bookings.availability.v2.EventTimeSlots.GetEventTimeSlot',
            url: resolveComWixpressBookingsAvailabilityV2EventTimeSlotsUrl({
                protoPath: '/v2/time-slots/event/{eventId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getEventTimeSlot.fromReq = fromReq;
    __getEventTimeSlot.__isAmbassador = true;
    return __getEventTimeSlot;
}
//# sourceMappingURL=http.impl.js.map